module.exports = __webpack_public_path__ + "img/icon-success.1f9ee697.svg";